<template>
  <div class="index">
     <ul style="overflow: auto;">
       <li @click="gopage('/newSale')">
           <img src="../assets/img/index/SalesBill.png">
           <h3>销售开单</h3>
       </li>
       <li  @click="gopage('/revenue')" >
         <img src="../assets/img/index/revenue.png">
         <h3><img src="../assets/img/blue.png" style="width: 26px; display: inline;position: relative;top:2px;left: -2px">营收概况</h3>
       </li>
       <li @click="gopage('/employeeyeji')">
         <img src="../assets/img/index/achievement.png">
         <h3><img src="../assets/img/blue.png" style="width: 26px; display: inline;position: relative;top:2px;left: -2px">员工业绩</h3>
       </li>
       <li @click="gopage('/goodslist')">
         <img src="../assets/img/index/guanli.png">
         <h3>商品管理</h3>
       </li>
       <li @click="gopage('/addpurc')">
         <img src="../assets/img/index/Copy.png">
         <h3>采购开单</h3>
       </li>
       <li @click="gopage('/history')">
         <img src="../assets/img/index/Purchase.png">
         <h3>采购历史</h3>
       </li>
       <li @click="gopage('/waterquery')">
         <img src="../assets/img/index/Stock.png">
         <h3>库存查询</h3>
       </li>
       <li @click="gopage('/surplus')">
         <img src="../assets/img/index/jinrijieyu.png">
         <h3> <img src="../assets/img/yellow1.png" style="width: 26px;position: relative;top: 3px;">今日结余</h3>
       </li>
     </ul>

  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      return {
        timer:null,

      }
    },

    mounted: function() {


    },
    created: function() {
      //DOM更新完之前请求数据
       setTimeout(()=>{
         let printproductids = JSON.parse(localStorage.getItem("shop")).printproductids
         if(!printproductids){
           localStorage.setItem('setpointSize', 'null') //切换店铺取消打印选择
         }
      },2000)
    },
    methods: {
      gopage(path){
        var shop = JSON.parse(localStorage.getItem("shop")).code;
        var shopArray = shop.split(",");
        if(path=='/surplus'){
            if( shopArray.indexOf('100060')>-1 || shopArray.indexOf('100051')>-1 || shopArray.indexOf('100059')>-1){

            }else {
              this.$Message.warning('亲,你还未购买此服务，暂时不能访问!');
              return
            }
        }else if(path=='/employeeyeji' || path=='/revenue'){ //蓝钻
          if( shopArray.indexOf('100060')>-1 || shopArray.indexOf('100051')>-1){

          }else {
            this.$Message.warning('亲,你还未购买此服务，暂时不能访问!');
            return
          }
        }
        this.$router.push({ path:path })
      }
    }
  }
</script>


<style  lang="scss" scoped>
 .index{
   ul{
     
     li{
       width: 350px;
       height: 160px;
       background-color: #6d93f2;
       box-shadow: 0px 3px 10px 0px
       rgba(24, 54, 129, 0.14);
       border-radius: 10px;
       opacity: 0.85;
       float: left;
       margin: 19px 18px;
       text-align: center;
       color: #ffffff;
       font-size: 22px;
       padding-top: 26px;
       cursor: pointer;
       img{
         display: inline-block;
       }
       h3{
         font-weight: normal;
         font-family: SimHei;
         padding-top: 10px;
       }
     }
     li:nth-child(2){
       background-color: #e766e8;
     }
     li:nth-child(3){
       background-color: #8580e0;
     }
     li:nth-child(4){
       background-color: #fe9c6b;
     }
     li:nth-child(5){
       background-color: #ed6b6b;
     }
     li:nth-child(6){
       background-color: #ffc44c;
     }
     li:nth-child(7){
       background-color: #4dbc86;
     }
     li:nth-child(8){
       background-color: #4572e6;
     }
   }
 }
</style>